import { useState } from 'react';
import { updateOrdenCompra } from '../../helpers/api_helper';

const useUpdateOrdenCompra = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const updateOrdenCompraHook = async (claemp, nroodc, data) => {
        setLoading(true);
        setError(null);
        try {
            const response = await updateOrdenCompra(claemp, nroodc, data);
            return response;
        } catch (err) {
            const errorMessage = `Failed to update orden compra: ${err.message || 'Unknown error'}`;
            setError(errorMessage);
            throw new Error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return { updateOrdenCompra: updateOrdenCompraHook, loading, error };
};

export default useUpdateOrdenCompra;